import { HttpInterceptorFn } from '@angular/common/http';
import { isTmsApiUrl } from './api.config';

export const apiCredentialsInterceptor: HttpInterceptorFn = (request, next) => {
  if (!isTmsApiUrl(request.url)) {
    return next(request);
  }

  return next(request.clone({ withCredentials: true }));
};
